var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathtemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 12H3.75V5.25C3.75 4.42289 4.42289 3.75 5.25 3.75C5.78208 3.75 6.24994 4.02867 6.51633 4.4475C5.74327 5.62908 5.82787 7.24012 6.83686 8.33977C6.64111 8.56069 6.64837 8.89833 6.85987 9.10983L7.39022 9.64017C7.60988 9.85983 7.96603 9.85983 8.18573 9.64017L12.6403 5.18569C12.8599 4.96603 12.8599 4.60987 12.6403 4.39017L12.1099 3.85983C11.8984 3.64833 11.5608 3.64111 11.3399 3.83681C10.4985 3.06483 9.35733 2.83233 8.33152 3.11658C7.6538 2.14064 6.52556 1.5 5.25 1.5C3.18225 1.5 1.5 3.18225 1.5 5.25V12H1.125C0.503672 12 0 12.5037 0 13.125V13.875C0 14.4963 0.503672 15 1.125 15H1.5V16.5C1.5 17.8327 2.07947 19.0298 3 19.8538V21.375C3 21.9963 3.50367 22.5 4.125 22.5H4.875C5.49633 22.5 6 21.9963 6 21.375V21H18V21.375C18 21.9963 18.5037 22.5 19.125 22.5H19.875C20.4963 22.5 21 21.9963 21 21.375V19.8538C21.9205 19.0298 22.5 17.8327 22.5 16.5V15H22.875C23.4963 15 24 14.4963 24 13.875V13.125C24 12.5037 23.4963 12 22.875 12Z",
    fill: "#A48111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtemp);
export default __webpack_public_path__ + "static/media/bathtemp.106ed77ade225caced34539bc79a9dab.svg";
export { ForwardRef as ReactComponent };